export default "__VITE_ASSET__ZdvkwPgk__"